import React from 'react';
import {
  Box,
  Tabs,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  CircularProgress,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import FormCheckbox from 'hook-form-controls/FormCheckbox';
import { RoleSwitch } from 'core/Role/RoleSwitch';

export default function RolePermissionForm({
  tabsConfig = [],
  tabsLoading = false,
  activeTab = 0,
  onTabChange,
  readOnly = false,
}) {
  const { control, setValue, watch } = useFormContext();
  const currentTab = tabsConfig[activeTab];

  if (tabsLoading) {
    return (
      <Box display="flex" alignItems="center" gap={1} py={4}>
        <CircularProgress size={24} />
        <Typography>Loading menu details...</Typography>
      </Box>
    );
  }

  const isAllEnabled = (sub) => {
    if (!sub.permissions?.length) return false;
    return sub.permissions.every(
      (perm) => watch(`menu_${currentTab.id}_${sub.id}_${perm.id}`) === true,
    );
  };

  const toggleAll = (sub, checked) => {
    sub.permissions?.forEach((perm) => {
      setValue(`menu_${currentTab.id}_${sub.id}_${perm.id}`, checked);
    });
  };

  return (
    <Box pt={3}>
      {tabsConfig.length > 1 && (
        <Tabs value={activeTab} onChange={(_, v) => onTabChange?.(v)}>
          {tabsConfig.map((tab) => (
            <Tab key={tab.id} label={tab.label} />
          ))}
        </Tabs>
      )}

      {currentTab && (
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: 'primary.main' }}>
              <TableCell sx={{ color: '#fff' }}>Sub-menu</TableCell>
              <TableCell sx={{ color: '#fff' }}>Permissions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {currentTab.subMenus?.map((sub) => (
              <TableRow key={sub.id}>
                <TableCell width="40%">
                  <Box display="flex" flexDirection="column" gap={1}>
                    <Typography fontWeight={600}>{sub.label}</Typography>

                    <Box display="flex" alignItems="center" gap={1}>
                      <Controller
                        name={`menu_${currentTab.id}_${sub.id}_enable_all`}
                        control={control}
                        render={({ field }) => (
                          <RoleSwitch
                            {...field}
                            checked={isAllEnabled(sub)}
                            disabled={readOnly}
                            onChange={(e) => {
                              if (readOnly) return;
                              const checked = e.target.checked;
                              field.onChange(checked);
                              toggleAll(sub, checked);
                            }}
                          />
                        )}
                      />
                      <Typography variant="body2">Enable All</Typography>
                    </Box>
                  </Box>
                </TableCell>

                <TableCell>
                  <Box display="grid" gridTemplateColumns="repeat(4,1fr)" gap={1.5}>
                    {sub.permissions?.map((perm) => (
                      <FormCheckbox
                        key={perm.id}
                        name={`menu_${currentTab.id}_${sub.id}_${perm.id}`}
                        label={perm.displayName}
                        disabled={readOnly}
                      />
                    ))}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
}
